var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('router-link',{staticClass:"link",attrs:{"to":"/terms"}},[_vm._v("Terms of Service")]),_c('span',{staticClass:"bullet"},[_vm._v("•")]),_c('a',{staticClass:"link",attrs:{"href":"mailto:contact@numer.ai"},on:{"click":_vm.contact}},[_vm._v("Contact Us")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }